class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    this.products = []

    this.init()
  }

  init() {
    const self = this

    if (self.products.length > 0) {
      return
    }
    fetch(this.dataset.url)
      .then((response) => {
        const { products } = response
        self.products = products
      })
      .then((response) => {
        const html = document.createElement('div')
        html.innerHTML = response
        const recommendations = html.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded')
        }

        window.addEventListener('load', function() {
          new Swiper('.product_recommendation_slider', {
            slidesPerView: 3,
            spaceBetween: 0,
            resistanceRatio : 0,
            breakpoints: {
              320: {
                slidesPerView: 2,
                loop: false,
                draggable: true,
              },
              641: {
                slidesPerView: 2.3,
                loop: true,
                navigation: false,
              },
              1025: {
                slidesPerView: 3,
                loop: false,
                navigation: false,
              },
            },
          })
        })
      })
      .catch(e => {
        console.error(e)
      })
  }
}

customElements.define('product-recommendations', ProductRecommendations)